import { useContext } from 'react';
import { AddressUpdateForm } from 'assets/js/pages/contacts/data-hygiene/AddressUpdateForm';
import { DataHygieneAddressContext } from 'assets/js/pages/contacts/data-hygiene/DataHygieneAddressContext';
import * as EditableInput from 'components/editable-input';
import { AddressReadable } from 'components/pages/campaign-settings/campaign-auction/AddressReadable';

const AddressUpdate = () => {
    const data = useContext(DataHygieneAddressContext);
    const { deliverability_status, original_data, provider_data } = data.address;
    const isChangeOfAddress = deliverability_status === 'change_of_address';

    if (deliverability_status === 'deliverable') {
        return null;
    }

    return (
        <div className="flex w-full min-w-72 flex-col gap-4 whitespace-normal">
            <div className="flex flex-col gap-1.5">
                <h3 className="font-medium text-gray-700">Current address</h3>
                <AddressReadable address={original_data} className="text-gray-600" />
            </div>

            {isChangeOfAddress ? (
                <div>
                    <EditableInput.Root className="flex flex-col gap-1.5">
                        <div className="flex gap-2">
                            <h3 className="font-medium text-gray-700">Updated address</h3>
                            <EditableInput.ReadOnlyEditTrigger />
                            <EditableInput.Cancel className="font-medium text-blue-700 hover:underline">
                                Close
                            </EditableInput.Cancel>
                        </div>

                        <EditableInput.ReadOnly className={'flex flex-col items-start'}>
                            <AddressReadable address={provider_data} className="text-gray-600" />
                            <AddressUpdateForm editable={false} />
                        </EditableInput.ReadOnly>
                        <EditableInput.Content>
                            <AddressUpdateForm />
                        </EditableInput.Content>
                    </EditableInput.Root>
                </div>
            ) : (
                <div className="flex flex-col gap-1.5">
                    <h3 className="font-medium text-gray-700">Updated address</h3>
                    <div>
                        <AddressUpdateForm />
                    </div>
                </div>
            )}
        </div>
    );
};

export { AddressUpdate };
